module.exports = __webpack_public_path__ + "img/智慧警务-综合业务管理平台V2.0.c858543c.jpg";